import { render } from "./ExhibitorKitPage.vue?vue&type=template&id=2781ba54"
import script from "./ExhibitorKitPage.vue?vue&type=script&lang=js"
export * from "./ExhibitorKitPage.vue?vue&type=script&lang=js"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__